export enum OrgSettingKey {
  UNDEFINED = '',
  RECURRING_TASK_RESET_DAYS_WEEKLY = 'recurringTaskResetDays.weekly',
  RECURRING_TASK_RESET_DAYS_MONTHLY = 'recurringTaskResetDays.monthly',
  RECURRING_TASK_RESET_DAYS_YEARLY = 'recurringTaskResetDays.yearly',

  TIME_TRACKING_ENABLED = 'time_tracking_enabled',
}
